import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper } from '@material-ui/core';
import { BigNumber } from 'bignumber.js';
import React, { useEffect, useState } from 'react';
import { Fare, FarePriceBreakdown, PriceBreakdownItem, VATTableItem } from '../Models';
import { formatDateEventualy, requestPrice } from '../utils';

export default (props: { fare: Fare; onClose: () => any }) => {
  let [error, setError] = useState<any>(undefined);

  let [loading, setLoading] = useState<boolean>(false);
  let [priceBreakdown, setPriceBreakdown] = useState<FarePriceBreakdown | undefined>(undefined);

  const getPrice = async (fare: Fare) => {
    if (loading || error) {
      return;
    }
    setLoading(true);

    try {
      const pbd = await requestPrice(fare);
      setPriceBreakdown(pbd);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!priceBreakdown) {
      getPrice(props.fare);
    }
  });

  const renderVATTableItem = (vati: VATTableItem) => {
    return (
      <li>
        <b>{new BigNumber(vati.vatRate).multipliedBy(100).toFixed(2)}% </b> - base: {vati.base}€ - montant: {vati.vat}€
      </li>
    );
  };

  const renderPriceBreakdownItem = (pbdi: PriceBreakdownItem) => {
    return (
      <li>
        {pbdi.title} {pbdi.label && <i>{pbdi.label}</i>} <br />
        HT:<b>{pbdi.price}€</b> <i>TVA {new BigNumber(pbdi.vatRate).multipliedBy(100).toFixed(2)}%</i>
      </li>
    );
  };

  const renderPriceBreakdown = (pbd: FarePriceBreakdown) => {
    let distanceSource = 'inconnue';
    if (pbd.pickedDistanceSource === 'distancemap') {
      distanceSource = 'distancier';
    } else if (pbd.pickedDistanceSource === 'geocode') {
      distanceSource = 'géocode';
    }

    let timePeriod = 'inconnue';
    switch (pbd.timeType) {
      case 'regular':
        timePeriod = 'jour';
        break;
      case 'night':
        timePeriod = 'nuit';
        break;

      case 'weekend':
        timePeriod = 'weekend / JF';
        break;
    }

    let invoiceDetails;
    if (pbd.priceBreakDown && pbd.priceBreakDown.length > 0) {
      invoiceDetails = pbd.priceBreakDown.map((p) => renderPriceBreakdownItem(p));
    } else {
      invoiceDetails = <li>Inconnu</li>;
    }

    let vatTable;
    if (pbd.vat && pbd.vat.length > 0) {
      vatTable = pbd.vat.map((p) => renderVATTableItem(p));
    } else {
      vatTable = <li>Inconnu</li>;
    }

    let totalPriceWithTax = 'inconnu';
    if ((pbd.totalVAT || pbd.totalVAT === '0.00') && pbd.totalPrice) {
      totalPriceWithTax = new BigNumber(pbd.totalVAT).plus(new BigNumber(pbd.totalPrice)).toFixed(2) + ' €';
    }

    return (
      // <Grid key={2} item xs={6}>
      <Paper elevation={4} style={{ padding: '16px', margin: '8px' }}>
        <h2>Tarif</h2>
        <h4>Distance retenue:</h4>
        <ul>
          <li>
            {pbd.pickedDistance || 'inconnu'}km (source: {distanceSource})
          </li>
        </ul>
        <h4>Horaires retenues:</h4>
        <ul>
          <li>
            <b>Départ</b>: {formatDateEventualy(pbd.pickedDepartureDate)}
          </li>
          <li>
            <b>Arrivée</b>: {formatDateEventualy(pbd.pickedArrivalDate)}
          </li>
          <li>
            <b>Periode</b>: {timePeriod}
          </li>
        </ul>
        <h4>Tarif appliqué:</h4>
        <ul>
          <li>{pbd.appliedTariff || 'inconnu'}</li>
        </ul>
        <h4>Lignes de facturation:</h4>
        <ul>{invoiceDetails}</ul>
        <h4>TVA: </h4>
        <ul>{vatTable}</ul>
        <h3>TOTAL:</h3>
        <ul>
          <li>HT: {pbd.totalPrice ? pbd.totalPrice + ' €' : 'inconnu'}</li>
          <li>TVA: {pbd.totalVAT || pbd.totalVAT === '0.00' ? pbd.totalVAT + ' €' : 'inconnu'}</li>
          <li>TTC: {totalPriceWithTax}</li>
        </ul>
      </Paper>
      // </Grid>
    );
  };

  const f = props.fare;
  return (
    <Dialog
      onClose={props.onClose}
      open={true}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <DialogTitle>
        Mission #{props.fare.identifier} en {f.transportType} commandée par {f.ordererId}
      </DialogTitle>
      <DialogContent>
        {/* <Grid
          container
          spacing={2}
          justify="space-around"
          style={{ padding: "16px" }}
        >
          <Grid key={1} item xs={6}> */}
        <Paper elevation={4} style={{ padding: '16px', margin: '8px' }}>
          <h3>
            Patient:{' '}
            {[
              props.fare.patientSex === 'M' ? 'M' : 'Mme',
              props.fare.patientFirstname,
              props.fare.patientLastname,
            ].join(' ')}{' '}
            - Transporteur: {props.fare.transporter}
          </h3>
          <h4>Départ</h4>
          <ul>
            <li>
              <b>Adresse</b>:
              {[
                props.fare.departure.placeName ? '(' + props.fare.departure.placeName + ')' : undefined,
                props.fare.departure.address,
                props.fare.departure.zip,
                props.fare.departure.city,
              ]
                .filter((e) => e !== undefined)
                .join(' ')}
            </li>
            <li>
              <b>ID Etablissement</b>: {props.fare.departureHC || 'inconnu'}
            </li>
            <li>
              <b>Horaire commande</b>: {formatDateEventualy(f.orderedLeaveDate)}
            </li>
            <li>
              <b>Horaire déclarée</b>: {formatDateEventualy(f.realStartDate)}
            </li>
          </ul>
          <h4>Arrivée:</h4>
          <ul>
            <li>
              <b>Adresse</b>:
              {[
                props.fare.arrival.placeName ? '(' + props.fare.arrival.placeName + ')' : undefined,
                props.fare.arrival.address,
                props.fare.arrival.zip,
                props.fare.arrival.city,
              ]
                .filter((e) => e !== undefined)
                .join(' ')}
            </li>
            <li>
              <b>ID Etablissement</b>: {props.fare.arrivalHC || 'inconnu'}
            </li>
            <li>
              <b>Horaire commande</b>: {formatDateEventualy(f.orderedArrivalDate)}
            </li>
            <li>
              <b>Horaire déclarée</b>: {formatDateEventualy(f.realEndDate)}
            </li>
          </ul>
        </Paper>
        {/* </Grid> */}
        {priceBreakdown && renderPriceBreakdown(priceBreakdown)}
        {/* </Grid> */}
      </DialogContent>
      <DialogActions>
        <Button
          type="button"
          color="secondary"
          onClick={() => {
            props.onClose();
          }}
        >
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  );
};
